import * as React from "react";
const SvgFiRrUfo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.995 9.755C18.865 6.009 15.778 3 12 3S5.135 6.009 5.005 9.755C.892 11.074 0 12.921 0 14.272 0 17.538 5.159 20 12 20s12-2.462 12-5.728c0-1.352-.892-3.198-5.005-4.518zM7 10c0-2.757 2.243-5 5-5s5 2.243 5 5v.134c-.586.308-2.055.866-5 .866-2.962 0-4.431-.564-5-.861zm5 8c-5.724 0-10-1.968-10-3.728 0-.928 1.349-1.891 3.643-2.622C6.346 12.122 8.169 13 12 13s5.654-.878 6.357-1.35c2.294.731 3.643 1.694 3.643 2.622C22 16.032 17.724 18 12 18m1.5-2.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001m-5.5-1a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 8 14.5m11 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 19 14.5"
    />
  </svg>
);
export default SvgFiRrUfo;
